import qs from "../node_modules/qs/lib/index"; // 按需导入qs模块:post请求用到
export default {

  /**
   * 位转数组
   */
  privilegeToValues (privilege) {
    let arr = []
    const QUERY = 1
    const ADD = 2
    const EDIT = 4
    const DEL = 8
    if ((privilege & QUERY) !== 0) {
      arr.push(QUERY)
    }
    if ((privilege & ADD) !== 0) {
      arr.push(ADD)
    }
    if ((privilege & EDIT) !== 0) {
      arr.push(EDIT)
    }
    if ((privilege & DEL) !== 0) {
      arr.push(DEL)
    }
    return arr
  },
  /**
   * 数组转位
   * @param {*} arr 
   * @returns 
   */
  valuesToPrivilege (arr) {
    let privilege = 0
    for (let i = 0; i < arr.length; i++) {
      privilege = (privilege | arr[i])
    }
    return privilege
  },
  companyDataToCompanyTree (arr, idkey = 'id') {
    let data = []
    for (let i = 0; i < arr.length; i++) {
      let item = arr[i]
      // 判断是否有父节点
      const index = arr.findIndex(c => c[idkey] === item.parentId)
      if (index === -1) {
        item.children = this.recursionData(arr, item[idkey], idkey)
        data.push(item)
      }
    }
    return data
  },
  recursionData (arr, pid, idkey) {
    let data = []
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].parentId === pid) {
        arr[i].children = this.recursionData(arr, arr[i][idkey], idkey)
        data.push(arr[i])
      }
    }
    return data
  },

  /**
   * 判断是否为数组  如果是数据转为json字符串
   * @param {*} arr 
   * @returns 
   */
  arrayToJsonString (arr) {
    if (arr instanceof Object) {
      return JSON.stringify(arr)
    }
    return arr
  },
  /**
   * post请求将参数数组都转换为字符串
   * @param {*} obj 
   */
  postParamsArrayToJsonString (obj) {
    if (!(obj instanceof Object)) {
      throw Error("传入参数不是对象")
    }
    for (let key in obj) {
      if (obj[key] instanceof Object) {
        obj[key] = JSON.stringify(obj[key])
      }
    }

    return qs.stringify(obj)
  },

  /**
   * 模拟api
   * @param {*} data 返回数据
   * @returns 
   */
  simulateReslut (data) {
    return new Promise((resolve, reject) => {
      let res = {
        data: data,
        errorCode: 0,
        errorStr: "成功",
        success: true,
      }
      resolve(res)
    })
  },
  getRequest(urlStr) {
    var url = "";
    if (typeof urlStr == "undefined") {
      url = decodeURI(location.search); //获取url中"?"符后的字符串
    } else {
      url = "?" + urlStr.split("?")[1];
    }
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
      var str = url.substr(1);
      var strs = [];
      strs = str.split("&");
      for (var i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  }
}